import { render } from "./PayloadMetadata.vue?vue&type=template&id=c48b9492&scoped=true"
import script from "./PayloadMetadata.vue?vue&type=script&lang=js"
export * from "./PayloadMetadata.vue?vue&type=script&lang=js"

import "./PayloadMetadata.vue?vue&type=style&index=0&id=c48b9492&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48b9492"]])

export default __exports__